import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CAPABILITIES } from '../data/content';
export function Capabilities() {
  return <section className="w-full bg-sand py-20 sm:py-24" data-id="element-37" data-mp="2l4tzmh9vs4v4">
      <div className="mx-auto max-w-4xl px-5" data-id="element-38" data-mp="2l4akf8bm7uks">
        <Reveal className="text-center" data-id="element-39" data-mp="2h3iasdytznnz">
          <p className="text-sm font-semibold uppercase tracking-widest text-clay" data-id="element-40" data-mp="2h4jwdcdh3sjy">
            Qué vas a poder hacer
          </p>
          <h2 className="mt-3 font-serif text-3xl font-semibold text-ink sm:text-4xl" data-id="element-41" data-mp="1tba4frzhcuya">
            Enseñá con más claridad, seguridad y estructura
          </h2>
        </Reveal>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-42" data-mp="2279cbemrlecm">
          {CAPABILITIES.map((item, i) => <Reveal key={item} as="li" delay={i % 2 * 0.06} className="flex items-start gap-3 rounded-xl border border-sand bg-cream p-4" data-id="element-43" data-mp="1xdyge8jhqhzh" data-mpi={i}>
              <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-sage/12 text-sage-deep" data-id="element-44" data-mp="15lzb2vkgm2u6">
                <SparklesIcon className="h-3.5 w-3.5" data-id="element-45" data-mp="polcbk1s5wr3" />
              </span>
              <span className="text-sm leading-relaxed text-ink/85" data-id="element-46" data-mp="pmqu4dhw8iqp">{item}</span>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}